<template>
  <b-card>

    <!-- media -->
    <b-media no-body>
      <b-media-aside>
        <b-link>
          <b-img
            ref="previewEl"
            rounded
            :src="authData.avatar"
            height="80"
          />
        </b-link>
        <!--/ avatar -->
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <!-- upload button -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          class="mb-75 mr-75"
          @click="$refs.refInputEl.$el.click()"
        >
          {{ $t('Upload')}}
        </b-button>
        <b-form-file
          ref="refInputEl"
          v-model="profileFile"
          accept=".jpg, .png, .gif, .jpeg"
          :hidden="true"
          plain
         
          @input="inputImageRenderer"
         
        />
        <!--/ upload button -->

        <!-- reset -->
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          size="sm"
          class="mb-75 mr-75"
        >
          {{ $t('Reset')}}

        </b-button>
        <!--/ reset -->
        <b-card-text>{{$t('Allowed JPG, GIF or PNG. Max size of 1000 kB')}}</b-card-text>
        <small v-if="errors && ('avatar' in errors)" class="text-danger">
              {{ $t(errors['avatar'][0]) }}
            </small>
      </b-media-body>
    </b-media>
    <!--/ media -->

    <!-- form -->
    <b-form class="mt-2" @submit.prevent="updateUser">
      <b-row>
        <b-col sm="12">
          <b-form-group
            label="Name"
            label-for="account-name"
          >
            <b-form-input
              v-model="authData.name"
              name="name"
              :state="errors && ('name' in errors) ? false : null"
              placeholder="Name"
            />
            <small v-if="errors && ('name' in errors)" class="text-danger">
              {{ $t(errors['name'][0]) }}
            </small>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="E-mail"
            label-for="account-e-mail"
          >
            <b-form-input
              v-model="authData.email"
              name="email"
              :state="errors && ('email' in errors) ? false : null"
              placeholder="Email"
            />
            <small v-if="errors && ('email' in errors)" class="text-danger">
              {{ $t(errors['email'][0]) }}
            </small>

          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            type="submit"
          >
            {{ $t('Save changes')}}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BFormFile, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import axios from '@/libs/axios'
import useHelpers from '@/views/modules/useHelpers'

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
  },
  directives: {
    Ripple,
  },
  props: {
    authData: {
      type: Object,
      default: () => {},
    },
    // errors: {
    //   type: Object,
    //   default: () => {}
    // }
  },
  setup(props,{root}) {

    const errors=ref([])
   const uploadImage=()=>{

    console.log('image upload ...')
   }

   const { toaster } = useHelpers(root)
   const updateUser=()=>{
    const name=props.authData.name;
    const profile= props.authData.avatar;
    
    


     return new Promise((resolve, reject) => {
      axios.post(`user/updateAvatar`,{"avatar":profile})
    
        .then(res =>{ 
         
           toaster(res.data)
        })
        .catch(reason => {
        errors.value=reason.response.data.errors;
          })
    })

   }
   
    const refInputEl = ref(null)
    const previewEl = ref(null)
    const profileFile = ref(null)


    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
    
        props.authData.avatar = base64
    })

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
      profileFile,
      updateUser,
      uploadImage
      ,errors
      
    }
  },
}
</script>
